import type { CSSProperties } from 'react'
import { colors } from 'settings/colors'
import type { TRect } from '../types'
import type { TPanelDragHandlers } from '../usePanelDrag'

export const BottomPanelHandle = ({
  rect,
  transition,
  isWideScreen,
  dragHandlers,
}: {
  rect: TRect
  transition: CSSProperties['transition']
  isWideScreen: boolean
  dragHandlers: TPanelDragHandlers
}) => (
  <>
    <div
      css={{
        position: 'fixed',
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        backgroundColor: colors.midnight,
        borderBottom: '1px solid #363F4F',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: isWideScreen ? 'ns-resize' : undefined,
      }}
      style={{ ...rect, transition }}
      {...dragHandlers}
    >
      <div
        css={{
          width: 47,
          height: 5,
          backgroundColor: colors.grey200,
          borderRadius: 10,
          alignSelf: 'flex-start',
          marginTop: 10,
        }}
      />
    </div>
    <div
      css={{
        position: 'fixed',
        right: 0,
        width: 38,
        borderTopRightRadius: 10,
        borderBottom: '1px solid #363F4F',
        background: `linear-gradient(270deg, ${colors.grey800} 5%, ${colors.midnight} 95%)`,
      }}
      style={{ top: rect.top, height: rect.height, transition }}
    />
  </>
)
